import { IDataSourceGroupData } from '../../data-source-types'

const isAggregateDataGroup = (group: IDataSourceGroupData): boolean =>
    group.DataItemIds === null && group.GroupByProperties.length === 0

export default isAggregateDataGroup
